<div class="modal-header">
  <h4 class="modal-title" id="modal-title">LEGS</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <AdminCard [Item]="LegsEntry">
    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <div class="form-floating">
            <input type="text" class="form-control" id="LEGS" [(ngModel)]="Item.legs">
            <label for="LEGS">LEGS</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <div class="form-floating mb-3">
            <input type="number" class="form-control" id="pg" step="1" min="0" [(ngModel)]="Item.pg">
            <label for="pg">PG</label>
          </div>
      </div>
    </div>
    <Date-Select [(Date)]="Item.gueltigBis" LabelText="Gültig ab"></Date-Select>
  </AdminCard>
  <div class="EditBtnRow row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-primary" (click)="Send()">Speichern</div>
    </div>
  </div>
</div>
